<child-header [title]="'Finish Association'" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
<table style="width: 100%;">
  <tr>
    <td colspan="2" style="font-weight: bold;">
      Association request has been submitted successfully, once it has been processed, it will become active. Until then this customer will be showing in your account with status "Pending Transfer". 
    </td>
  </tr>
  <tr>
    <td>
      Transfer ID: 
    </td>
    <td>
      <span style="font-weight: bold;"> {{ data.transferId }}</span>
    </td>
  </tr>
  <tr>
    <td>
      Customer ID: 
    </td>
    <td>
      <span style="font-weight: bold;"> {{ data.customerId }}</span>
    </td>
  </tr>

</table>
 
</div>
<div class="nce-dialog-action">
  <button mat-button class="button button-red button-large nce-large-button continue" 
    (click)="goToCustomer()">Go to Customer</button>
</div>
